export enum SortType {
    none = 0,
    ascending = 1,
    descending = -1,
}
